import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { RecuperarComponent } from './components/shared/recuperar/recuperar.component';
import { CambiarcontraComponent } from './components/shared/cambiarcontra/cambiarcontra.component';
import { MitrabajoComponent } from './components/secciones/mitrabajo/mitrabajo.component';
import { CalendarioComponent } from './components/secciones/calendario/calendario.component';
import { PerfilComponent } from './components/secciones/perfil/perfil.component';
import { AgregarusuariosComponent } from './components/secciones/agregarusuarios/agregarusuarios.component';
import { ColorPickerModule } from '@syncfusion/ej2-angular-inputs';
import { enableRipple } from '@syncfusion/ej2-base';
import { TareasComponent } from './components/tareas/tareas/tareas.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InformacionComponent } from './components/tareas/informacion/informacion.component';
import { AgregarComponent } from './components/tareas/agregar/agregar.component';
import { InfoComponent } from './components/tareas/info/info.component';
import { AddUsuariosComponent } from './components/tareas/add-usuarios/add-usuarios.component';
import { EditarTareaComponent } from './components/tareas/editar-tarea/editar-tarea.component';
import { EstatusComponent } from './components/tareas/estatus/estatus.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CKEditorModule } from 'ckeditor4-angular';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    RecuperarComponent,
    CambiarcontraComponent,
    MitrabajoComponent,
    CalendarioComponent,
    PerfilComponent,
    AgregarusuariosComponent,
    TareasComponent,
    InformacionComponent,
    AgregarComponent,
    InfoComponent,
    AddUsuariosComponent,
    EditarTareaComponent,
    EstatusComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    ColorPickerModule,
    NgbModule,
    CKEditorModule,
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory })
    
    ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
